const grid = {
  templateColumns: 'repeat(12, [col-start] minmax(0, 1fr) [col-end])',
  columnGap: ['16px', '24px']
}

export default grid
